import { useMutation, type MutationHookOptions } from "@apollo/client"
import tenantRemoveManyMutation from "@/v2-backoffice-client/tenant/remove/many/tenant.remove.many.mutation.gql"
import type {
  TenantRemoveManyMutation,
  TenantRemoveManyMutationVariables,
} from "@/v2-backoffice-client/tenant/remove/many/__types__/tenant.remove.many.mutation"

type RemoveOptions = MutationHookOptions<
  TenantRemoveManyMutation,
  TenantRemoveManyMutationVariables
>

export function useTenantRemoveManyMutation(options?: RemoveOptions) {
  return useMutation<
    TenantRemoveManyMutation,
    TenantRemoveManyMutationVariables
  >(tenantRemoveManyMutation, options)
}
